import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { ButtonUI } from '../Interface';
import CommentCard from './CommentCard';
import commentService from '../../service/comment.service';
import { sxConfig } from './comment.style';
import CommentMessageField from './CommentMessageField';
import addNotification from '../../utils/addNotification';
import { NotificationType } from '../../config';
import masterDataService from '../../service/masterData.service';
import useUsers from '../../context/UsersContext';

const Comments = ({
  rows,
  lineId,
  subMenuUrl,
  setRefetchTable = () => {},
  onCommentsChange = () => {},
  disabled,
  onResponsiblePersonsAdded = () => {},
}) => {
  const { getUser, user } = useUsers();
  const [comments, setComments] = useState([]);
  const [isAdding, setIsAdding] = useState(false);
  const [newMessage, setNewMessage] = useState('');
  const [editing, setEditing] = useState(null);
  const [users, setUsers] = useState([]);
  const [mentionedUserIds, setMentionedUserIds] = useState([]);

  useEffect(() => {
    setComments(rows);
  }, [rows]);

  useEffect(() => {
    if (!Object.keys(user).length) getUser();
    getUsersToForm();
  }, []);

  const getUsersToForm = () => {
    masterDataService.usersToForm().then((data) => {
      setUsers(data);
    });
  };

  const handleCreate = () => {
    const body = {
      message: newMessage,
      mentionedUserIds,
      subMenuUrl,
      lineId,
    };

    commentService.createItem(body).then((data) => {
      const { addedResponsiblePersons = [], ...comment } = data;

      setComments((prev) => {
        const updatedComments = [comment, ...prev];

        onCommentsChange(updatedComments.length);

        return updatedComments;
      });

      if (addedResponsiblePersons.length > 0) {
        onResponsiblePersonsAdded(addedResponsiblePersons);
      }

      resetForm();
      setRefetchTable(true);
    });
  };

  const handleRemove = (id) => {
    if (disabled) {
      addNotification({
        content: 'Kapcsoljon szerkesztési módba!',
        type: NotificationType.WARNING,
      });
      return;
    } else {
      commentService.deleteItem(id).then(() => {
        setComments((prev) => {
          const updatedComments = prev.filter((comment) => comment.id !== id);

          onCommentsChange(updatedComments.length);

          return updatedComments;
        });
        setRefetchTable(true);
      });
    }
  };

  const handleUpdate = () => {
    const body = {
      id: editing.id,
      message: editing.message,
    };

    commentService.updateItem(body).then((data) => {
      setComments((prev) =>
        prev.map((item) =>
          item.id === editing.id ? { ...item, message: data.message, updatedBy: data.updatedBy } : item
        )
      );
      setEditing(null);
      setRefetchTable(true);
    });
  };

  const handleStartCreate = () => {
    if (disabled) {
      addNotification({
        content: 'Kapcsoljon szerkesztési módba!',
        type: NotificationType.WARNING,
      });
      return;
    } else {
      setIsAdding(true);
      setEditing(null);
    }
  };

  const handleStartEdit = (row) => {
    if (disabled) {
      addNotification({
        content: 'Kapcsoljon szerkesztési módba!',
        type: NotificationType.WARNING,
      });
      return;
    } else {
      setIsAdding(false);
      setNewMessage('');
      setEditing({ id: row.id, message: row.message });
    }
  };

  const resetForm = () => {
    setIsAdding(false);
    setNewMessage('');
    setMentionedUserIds([]);
  };

  return (
    <>
      <Box sx={sxConfig.container}>
        {isAdding ? (
          <CommentMessageField
            users={users}
            onChange={(e) => setNewMessage(e.target.value)}
            value={newMessage}
            mentionedUserState={{ mentionedUserIds, setMentionedUserIds }}
          />
        ) : (
          <Box onClick={handleStartCreate} sx={sxConfig.inputWrapper}>
            <Typography component="span" sx={sxConfig.placeholderText}>
              Hozzászólás írása...
            </Typography>
          </Box>
        )}
      </Box>

      {isAdding && (
        <Box sx={sxConfig.buttonWrapper}>
          <ButtonUI
            text="Mentés"
            className="bg-[#669DF1] mt-2"
            size="sm"
            disabled={!newMessage.trim().length > 0}
            onClick={handleCreate}
          />
          <ButtonUI text="Mégsem" className="bg-[#949494] mt-2" size="sm" onClick={resetForm} />
        </Box>
      )}
      {comments.map((comment) => (
        <CommentCard
          key={comment.id}
          comment={comment}
          handleRemove={handleRemove}
          handleStartEdit={handleStartEdit}
          handleUpdate={handleUpdate}
          editingState={{ editing, setEditing }}
        />
      ))}
    </>
  );
};

export default Comments;
